/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useUserCurrentSubprofileSelector } from "@nf/common";
import { ROUTES } from "@nf/constants";
import React from "react";
import cx from "classnames";

import { LinkWithLocale } from "components";
import { useBrandingLogo } from "hooks";

import styles from "./HeaderLogo.module.scss";

interface HeaderLogoProps {
  className?: string;
}

export const HeaderLogo = ({ className }: HeaderLogoProps) => {
  const currentProfile = useUserCurrentSubprofileSelector();
  const logo = useBrandingLogo();
  const link = currentProfile?.Child ? ROUTES.KIDS : ROUTES.HOME;

  return (
    <LinkWithLocale href={link}>
      <a className={cx(styles.link, className)}>
        <img alt="Logo" className={styles.logo} src={logo} />
      </a>
    </LinkWithLocale>
  );
};

export default HeaderLogo;
